<div class="content-card">
  <h2 class="content-card__header">{{ 'DSS-DelegationCosts' | translate }} </h2>

  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col-12 col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'DCL-InvoiceNumber' | translate }}</mat-label>
          <input matInput formControlName="invoiceNumber" maxlength="200" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'DCL-Description' | translate }}</mat-label>
          <input matInput formControlName="description" maxlength="200" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-12">
        <mat-form-field fxFill appearance="outline">
          <mat-label>{{ 'DCL-PaymentType' | translate }}</mat-label>
          <mat-select formControlName="paymentTypeId">
            <mat-option *ngFor="let paymentType of listOfPaymentTypes$ | async" [value]="paymentType.Id">
              {{ paymentType.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'DCL-DocumentDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="documentDatePicker" [matDatepickerFilter]="documentDateFilter" formControlName="documentDate" readonly />
          <mat-datepicker-toggle matSuffix [for]="documentDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #documentDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'DCL-SalesDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="salesDatePicker" [matDatepickerFilter]="salesDateFilter" formControlName="salesDate" readonly />
          <mat-datepicker-toggle matSuffix [for]="salesDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #salesDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div formArrayName="invoiceItems">
      <div *ngFor="let item of invoiceItems.controls; let i = index" [formGroupName]="i" class="invoice-item">
        <div class="invoice-item-header">
          <h4>{{ 'DCL-Item' | translate : { index: i + 1 } }}</h4>

          <button mat-icon-button (click)="removeItem(i)" *ngIf="isEditMode && invoiceItems.length > 1">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <mat-divider></mat-divider>

        <div class="row">
          <div class="col-12 col-md-8">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DCL-Description' | translate }}</mat-label>
              <input matInput formControlName="name" maxlength="250" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DCL-Category' | translate }}</mat-label>
              <mat-select formControlName="categoryId">
                <mat-option *ngFor="let invoiceType of listOfDelegationInvoiceTypes$ | async" [value]="invoiceType.Id">
                  {{ invoiceType.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DCL-NetValue' | translate }}</mat-label>
              <input matInput type="number" formControlName="netValue" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DCL-Currency' | translate }}</mat-label>
              <mat-select formControlName="currencyId">
                <mat-option *ngFor="let currency of listOfCurrencies$ | async" [value]="currency.Id">
                  {{ currency.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DCL-Vat' | translate }}</mat-label>
              <mat-select formControlName="vatId">
                <mat-option *ngFor="let vat of listOfValueAddedTaxes$ | async" [value]="vat.Id">
                  {{ vat.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DCL-VatValue' | translate }}</mat-label>
              <input matInput type="number" formControlName="vatValue" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DCL-GrossValue' | translate }}</mat-label>
              <input matInput type="number" formControlName="grossValue" />
            </mat-form-field>
          </div>
        </div>
      </div>
      <mat-divider class="my-3"></mat-divider>
    </div>

    <button *ngIf="isEditMode" mat-raised-button color="accent" (click)="addItem()"><mat-icon>add</mat-icon>{{ 'DCL-AddItem' | translate }}</button>

    <div class="mt-4">
      <h3>{{ 'DCL-Summary' | translate }}</h3>
      <div class="row">
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DCL-NetValue' | translate }}</mat-label>
            <input matInput formControlName="totalNetValue" readonly />
          </mat-form-field>
        </div>
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DCL-VatValue' | translate }}</mat-label>
            <input matInput formControlName="totalVatValue" readonly />
          </mat-form-field>
        </div>
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DCL-GrossValue' | translate }}</mat-label>
            <input matInput formControlName="totalGrossValue" readonly />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="upload" *ngIf="isEditMode">
      <fileUpload [maxFileCount]="maxFileCount" (onFilesChange)="onFilesChange($event)"></fileUpload>
    </div>

    <div *ngIf="savedFiles && savedFiles.length > 0">
      <div class="header-wrapper">
        <h3 class="content-card__header">{{ 'DSS-Attachments' | translate }}</h3>
      </div>
      <ul>
        <li *ngFor="let file of savedFiles">
          <div class="file-row">
            <p>{{ file.FileName }}</p>
            <a (click)="downloadCostFile(file.Id, file.FileName)"><mat-icon>file_download</mat-icon></a>
            <a (click)="viewCostFile(file.Id, file.FileName)"><mat-icon>find_in_page</mat-icon></a>
          </div>
        </li>
      </ul>
    </div>

    <div fxLayout="row" fxLayoutAlign="end space-between center">
      <button id="delegation-add-invoice-form-close-button" mat-raised-button color="accent" (click)="close()">{{ 'Close' | translate }}</button>
      <button id="delegation-add-invoice-form-save-button" *ngIf="isEditMode" mat-raised-button color="primary" (click)="saveCost()" [disabled]="!isSaveButtonEnabled()">{{ 'Save' | translate }}</button>
    </div>
  </form>
</div>
